import React, { useState, useEffect } from 'react';
import { Form, Button, Select, Input, message } from 'antd';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

import BannerTypeService from '../../services/BannerTypeService';
import BannerLocationService from '../../services/BannerLocationService';
const layout = {
	labelCol: {
		span: 8,
	},
	wrapperCol: {
		span: 12,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 8,
		span: 16,
	},
};

const BannerEditForm = ({ banner, fetchBanner, updateBanner, setEditModal, setRefresh }) => {
	const [bannerType, setBannerType] = useState();
	const [bannerLocation, setBannerLocation] = useState();

	const onFinish = async (values) => {
		await updateBanner(banner?._id, values);
		await fetchBanner();
		setEditModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};
	useEffect(() => {
		BannerTypeService.getBannerType()
			.then((data) => setBannerType(data.data))
			.catch(() => message.error('fetching banner locatiom Failed'));

		BannerLocationService.getBannerLocations()
			.then((data) => setBannerLocation(data.data))
			.catch(() => message.error('fetching banner location Failed'));
	}, []);
	return (
		<Form
			{...layout}
			name="BannerEditForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item
				initialValue={banner?.name}
				label="Company Name"
				name={['name']}
				rules={InputRules.required('Please enter name!')}
			>
				<Input placeholder="Enter company name" />
			</Form.Item>
			<Form.Item
				initialValue={banner?.link}
				label="Link"
				name={['link']}
				rules={InputRules.required('Please enter link!')}
			>
				<Input placeholder="Enter link " />
			</Form.Item>
			<Form.Item initialValue={banner?.active} label="Ad Banner Status Active" name={['active']}>
				<Select showSearch allowClear={true} placeholder="Select Ad status">
					<Select.Option value={1}>True</Select.Option>
					<Select.Option value={0}>False</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item name={['bannerType']} label="Ad Banner Type">
				<Select placeholder="Select Banner Type">
					{bannerType?.map((data, index) => (
						<Select.Option key={index} value={data.name}>
							{data.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				initialValue={banner?.location}
				label="Ad Location"
				name={['location']}
				rules={InputRules.required('Please select Ad location!')}
			>
				<Select showSearch allowClear={true} placeholder="Select Ad location" mode="tags">
					{bannerLocation?.map((data, index) => (
						<Select.Option key={index} value={data.name}>
							{data.name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				initialValue={banner?.type}
				label="Type"
				name={['type']}
				rules={InputRules.required('Please select Type!')}
			>
				<Select showSearch allowClear={true} placeholder="Select Type" mode="tags">
					<Select.Option value={'landscape'}>Landscape</Select.Option>
					<Select.Option value={'portrait'}>Portrait</Select.Option>
				</Select>
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update Banner
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	fetchBanner: () => dispatch(Actions.fetchBanner()),
	updateBanner: (id, body) => dispatch(Actions.updateBanner(id, body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BannerEditForm);
